export default __webpack_public_path__ + "static/media/Logitech.6f029497.svg";